import { ReactElement, useEffect, useState } from "react";
import { ReactSVG } from "react-svg";
import { ColumnsType } from "antd/es/table";

import "./documents.scss";
import CustomTable from "../../../../components/custom-table/custom-table";
import CustomModal from "../../../../components/custom-modal/custom-modal";
import DeleteModal from "../../../../components/delete-modal/delete-modal";
import { useNavigate, useParams } from "react-router-dom";
import { useDispatch } from "react-redux";
import { LOADING } from "../../../../store/actions";
import { AxiosResponse } from "axios";
import instance from "../../../../store/axios";
import moment from "moment";
import { isImageFile } from "../../../../utils/helper/functions";
import toast from "react-hot-toast";
import { Image } from "antd";
import PdfViewer from "../../../../components/pdf-viewer";

interface DocumentProps {
  [key: string]: any;
}

const Documents: React.FC<DocumentProps> = ({
  accountKycDetails,
}: DocumentProps): ReactElement => {
  const { accountId, activeKyc, documentId } = useParams();
  // eslint-disable-next-line no-restricted-globals
  const queryParams = new URLSearchParams(location.search);
  const isApproveCase = queryParams.get("approve");
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [openDeleteModal, setOpenDeleteModal] = useState<boolean>(false);
  const [documents, setDocuments] = useState<any>([]);
  const [secondTableDocuments, setSecondTableDocuments] = useState<any>([]);
  const [openPdfViewerModal, setOpenPdfViewerModal] = useState<boolean>(false);
  const [selectedDocument, setSelectedDocument] = useState<any>({});

  useEffect(() => {
    localStorage.removeItem("docType");
    localStorage.removeItem("storagePath");
    localStorage.removeItem("documentExtension");
  }, []);

  useEffect(() => {
    if (
      accountKycDetails?.id &&
      (accountKycDetails?.activeDocumentsId ||
        accountKycDetails?.pendingDocumentsId)
    ) {
      getDocumentsApi();
    }
  }, [accountKycDetails]);

  const getDocumentsApi = async (): Promise<void> => {
    dispatch({ type: LOADING, payload: true });

    try {
      let response: AxiosResponse<DocumentProps> =
        {} as AxiosResponse<DocumentProps>;
      if (isApproveCase && accountKycDetails?.pendingDocumentsId) {
        response = await instance.get(
          `/${process.env.REACT_APP_ENDPOINT_VERSION}/files/account/${accountId}?accountDocumentId=${accountKycDetails?.pendingDocumentsId}`
        );
      } else {
        response = await instance.get(
          `/${process.env.REACT_APP_ENDPOINT_VERSION}/files/account/${accountId}?accountDocumentId=${
            accountKycDetails?.activeDocumentsId ||
            accountKycDetails?.pendingDocumentsId
          }`
        );
      }
      setDocuments(
        response.data.filter((document: any) => {
          return (
            document?.documentType?.id !== 128 &&
            document?.documentType?.id !== 129 &&
            document?.documentType?.id !== 130
          );
        })
      );
      setSecondTableDocuments(
        response.data.filter((document: any) => {
          return (
            document?.documentType?.id === 128 ||
            document?.documentType?.id === 129 ||
            document?.documentType?.id === 130
          );
        })
      );
    } catch (error: any) {
      if (error?.response?.status !== 401) {
        toast.error(error?.response?.data?.message || "An error occurred");
      }
      localStorage.setItem(
        "star_prev_url",
        `/home/business-account/${accountId}/${activeKyc}/details`
      );
    }

    dispatch({ type: LOADING, payload: false });
  };

  const columns: ColumnsType<any> = [
    {
      title: "#",
      dataIndex: "id",
      key: "id",
      fixed: "left",
      render: (_, __, index: number) => <span>{index + 1}</span>,
    },
    {
      title: "File type",
      dataIndex: "documentType",
      key: "documentName",
      width: 270,
      sorter: (a, b) =>
        String(a?.documentType?.description).localeCompare(
          String(b?.documentType?.description)
        ),
      fixed: "left",
      render: (_, record) => (
        <span>
          {record?.documentType?.description === "Other Documents"
            ? `${record?.otherDocName || 'Other document'}`
            : record?.documentType?.description}
        </span>
      ),
    },
    {
      title: "Document",
      dataIndex: "storagePath",
      key: "storagePath",
      render: (text, record) =>
        isImageFile(record.documentExtension) ? (
          <Image src={text} width={"80px"} height={"50px"} alt="" />
        ) : (
          <span
            className="cursor-pointer"
            onClick={() => {
              setSelectedDocument(record);
              setOpenPdfViewerModal(true);
            }}
          >
            {record.documentName}
          </span>
        ),
    },
    {
      title: "Created at",
      dataIndex: "createdAt",
      key: "createdAt",
      width: 190,
      sorter: (a, b) =>
        moment(a?.createdAt).isBefore(moment(b?.createdAt)) ? -1 : 1,
      render: (text) => (
        <span className="text-gray-500">
          {moment(text).format("MMM DD, YYYY hh:mm A")}
        </span>
      ),
    },
    {
      title: "Updated at",
      dataIndex: "updatedAt",
      key: "updatedAt",
      width: 190,
      sorter: (a, b) =>
        moment(a?.updatedAt).isBefore(moment(b?.updatedAt)) ? -1 : 1,
      render: (text) => (
        <span className="text-gray-500">
          {moment(text).format("MMM DD, YYYY hh:mm A")}
        </span>
      ),
    },
    {
      title: "Actions",
      key: "actions",
      render: (_, record) => (
        <div className="actions flex align-center">
          <ReactSVG
            src={"/images/edit.svg"}
            onClick={() => {
              localStorage.setItem("docType", record?.documentType?.id);
              localStorage.setItem("storagePath", record?.storagePath);
              localStorage.setItem(
                "documentExtension",
                record?.documentExtension
              );
              navigate(`/document/${accountId}/${activeKyc}/edit`);
            }}
          />
          {/* <ReactSVG
            className="delete-icon"
            src={"/images/delete.svg"}
            onClick={() => setOpenDeleteModal(true)}
          /> */}
        </div>
      ),
    },
  ];

  return (
    <section className="flex flex-col w-full h-full">
      <div className="documents-container flex flex-col">
        <CustomTable
          columns={columns}
          data={documents}
          showPagination={false}
        />

        <div className="mt-9"></div>
        {secondTableDocuments?.length ? (
          <CustomTable
            columns={columns}
            data={secondTableDocuments}
            showPagination={false}
            style={{ marginTop: "40px" }}
          />
        ) : (
          ""
        )}
        <CustomModal
          isVisible={openDeleteModal}
          centered
          width={450}
          onClose={() => {
            setOpenDeleteModal(false);
          }}
          className="delete-modal"
        >
          <DeleteModal
            onCancel={() => setOpenDeleteModal(false)}
            text="Delete document!"
            subText="Are you sure to delete this document?"
          />
        </CustomModal>
        <CustomModal
          isVisible={openPdfViewerModal}
          centered
          width={1100}
          showClose={false}
          onClose={() => {
            setOpenPdfViewerModal(false);
          }}
          className="edit-modal"
        >
          <div className="flex flex-col items-center justify-center">
            <PdfViewer fileUrl={selectedDocument?.storagePath} />
          </div>
        </CustomModal>
      </div>
    </section>
  );
};

export default Documents;
